import { useEffect, useState } from "react";

const NARROW_BREAKPOINT = 768;

export const useExpedienteNarrowLayout = () => {
  const [isNarrow, setIsNarrow] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < NARROW_BREAKPOINT;
  });

  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth < NARROW_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isNarrow;
};
